import { Routes } from '@angular/router';
import { authGuard } from './guards/auth.guard';
import { adminGuard } from './guards/admin.guard';

export const routes: Routes = [
  {
    path: '',
    loadComponent: () => import('./components/home/home.component').then(m => m.HomeComponent)
  },
  {
    path: 'programs',
    loadComponent: () => import('./components/programs/programs.component').then(m => m.ProgramsComponent)
  },
  {
    path: 'register',
    loadComponent: () => import('./components/registration/registration.component').then(m => m.RegistrationComponent)
  },
  {
    path: 'booking',
    loadComponent: () => import('./components/booking-calendar/booking-calendar.component').then(m => m.BookingCalendarComponent)
  },
  {
    path: 'admin',
    loadComponent: () => import('./components/admin-shell/admin-shell.component').then(m => m.AdminShellComponent),
    canActivate: [adminGuard],
    children: [
      {
        path: '',
        loadComponent: () => import('./components/admin-dashboard/admin-dashboard.component').then(m => m.AdminDashboardComponent)
      },
      {
        path: 'bookings',
        loadComponent: () => import('./components/admin-all-bookings/admin-all-bookings.component').then(m => m.AdminAllBookingsComponent)
      },
      {
        path: 'block-slot',
        loadComponent: () => import('./components/admin-block-slot/admin-block-slot.component').then(m => m.AdminBlockSlotComponent)
      },
      {
        path: 'gallery',
        loadComponent: () => import('./components/admin-gallery/admin-gallery.component').then(m => m.AdminGalleryComponent)
      },
      {
        path: 'new-registrations',
        loadComponent: () => import('./components/admin-new-registrations/admin-new-registrations.component').then(m => m.AdminNewRegistrationsComponent)
      }
    ]
  },
  {
    path: 'contact',
    loadComponent: () => import('./components/contact-us/contact-us.component').then(m => m.ContactUsComponent)
  },
  {
    path: 'about',
    loadComponent: () => import('./components/about-us/about-us.component').then(m => m.AboutUsComponent)
  },
  {
    path: 'gallery',
    loadComponent: () => import('./components/gallery/gallery.component').then(m => m.GalleryComponent)
  },
  {
    path: 'font-test',
    loadComponent: () => import('./components/font-test/font-test.component').then(m => m.FontTestComponent)
  },
  {
    path: 'instructors-founders',
    loadComponent: () => import('./components/instructors-founders/instructors-founders.component').then(m => m.InstructorsFoundersComponent)
  },
  {
    path: 'store',
    loadComponent: () => import('./components/store/store.component').then(m => m.StoreComponent)
  },
  {
    path: 'signin',
    loadComponent: () => import('./components/signin/signin.component').then(m => m.SigninComponent)
  },
  {
    path: 'signup',
    loadComponent: () => import('./components/signup/signup.component').then(m => m.SignupComponent)
  },
  {
    path: 'forgot-password',
    loadComponent: () => import('./components/forgot-password/forgot-password.component').then(m => m.ForgotPasswordComponent)
  },
  {
    path: 'terms-and-conditions',
    loadComponent: () => import('./components/terms-and-conditions/terms-and-conditions.component').then(m => m.TermsAndConditionsComponent)
  },
  {
    path: 'privacy-policy',
    loadComponent: () => import('./components/privacy-policy/privacy-policy.component').then(m => m.PrivacyPolicyComponent)
  },
  {
    path: 'payment',
    loadComponent: () => import('./components/payment/payment.component').then(m => m.PaymentComponent),
    canActivate: [authGuard]
  },
  {
    path: 'payment-success',
    loadComponent: () => import('./components/payment-success/payment-success.component').then(m => m.PaymentSuccessComponent),
    canActivate: [authGuard]
  },
  {
    path: 'payment-failed',
    loadComponent: () => import('./components/payment-failed/payment-failed.component').then(m => m.PaymentFailedComponent),
    canActivate: [authGuard]
  },
  {
    path: 'my-bookings',
    loadComponent: () => import('./components/my-bookings/my-bookings.component').then(m => m.MyBookingsComponent),
    canActivate: [authGuard]
  },
  {
    path: 'profile',
    loadComponent: () => import('./components/profile/profile.component').then(m => m.ProfileComponent),
    canActivate: [authGuard]
  }
];
